import React from 'react';

function Index(props) {
  const {title = '',} = props;
  return (
    <fieldset style={{borderColor: 'rgba(51,161,55,0.84)', borderRadius: 10, paddingLeft: 20,paddingTop:20, paddingBottom:20}}>
      <legend className='heading-color  text-capitalize pl-5 pr-5'>{title}</legend>
      {props.children}
    </fieldset>
  );
}

export default Index;
